export const AppointmentScheduledIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={`${className} fill-white`}
         dangerouslySetInnerHTML={{
            __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="inherit">
          <g clip-path="url(#clip0_839_200)">
            <path d="M0 6V5.25C0 3.18225 1.68225 1.5 3.75 1.5H4.5V0.75C4.5 0.336 4.83525 0 5.25 0C5.66475 0 6 0.336 6 0.75V1.5H12V0.75C12 0.336 12.3352 0 12.75 0C13.1648 0 13.5 0.336 13.5 0.75V1.5H14.25C16.3177 1.5 18 3.18225 18 5.25V6H0ZM18 7.5V14.25C18 16.3177 16.3177 18 14.25 18H3.75C1.68225 18 0 16.3177 0 14.25V7.5H18ZM13.374 9.864C13.086 9.56625 12.612 9.55725 12.3135 9.8445L8.748 13.281C8.466 13.563 7.99275 13.584 7.66875 13.2615L5.96025 11.6737C5.658 11.3925 5.184 11.4082 4.9005 11.7127C4.6185 12.0157 4.63575 12.4905 4.9395 12.7725L6.6285 14.3415C7.053 14.7667 7.6185 15.0007 8.21925 15.0007C8.82 15.0007 9.38625 14.7668 9.80025 14.3512L13.3552 10.9253C13.653 10.638 13.662 10.1618 13.374 9.864Z" fill="inherit"/>
          </g>
          <defs>
            <clipPath id="clip0_839_200">
              <rect width="18" height="18" fill="inherit"/>
            </clipPath>
          </defs>
        </svg>
    `,
         }}
      />
   )
}
